import React from 'react';
import { Modal } from '@fortress-technology-solutions/fortress-component-library/Molecules_Fortress';
import { Form } from '@fortress-technology-solutions/fortress-component-library/Organisms';
import { AlertInfoIcon } from '@fortress-technology-solutions/fortress-component-library/Icons';

import useApprovalStatusModal from './hooks';

export default function ApprovalStatusModal({
  open,
  handleClose,
  applicant,
  deniedReasons,
  approveApplicant,
  cancelApplicant,
  checklistApproved,
  applicationComplete,
}) {
  const {
    reactHookFormProps,
    formFields,
    handleSave,
    saving,
    handleCloseModal,
    disableSubmit,
  } = useApprovalStatusModal({
    applicant,
    handleClose,
    deniedReasons,
    approveApplicant,
    cancelApplicant,
    checklistApproved,
    applicationComplete,
  });

  return (
    <Modal
      open={open}
      onClose={handleCloseModal}
      title={`Approval Status for ${applicant.name}`}
      icon={<AlertInfoIcon />}
      actionsProps={[
        {
          variant: 'text',
          children: 'Cancel',
          onClick: handleCloseModal,
        },
        {
          children: 'Confirm & Submit',
          submitButton: true,
          onClick: handleSave,
          disabled: disableSubmit,
          isSubmitting: saving,
        },
      ]}
      ContentProps={{
        sx: {
          width: {
            xs: 'calc(100% - 32px)',
            sm: 500,
          },
        },
      }}
    >
      <Form
        spacing={3}
        ReactHookFormProps={reactHookFormProps}
        fields={formFields}
      />
    </Modal>
  );
}
